import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Translate } from '../../../../shared/LanguageService';
import UnbookedOrdersList from './UnbookedOrdersList';
import { UnbookedOrder } from '../../types';

type UnbookedOrdersDialogProps = {
    orders: UnbookedOrder[];
    open: boolean;
    showBrokerFirm: boolean;
    returnTo: string;
    onClose: () => void;
};

const TitleId = 'unbooked-orders-dialog-title';

function UnbookedOrdersDialog({
    orders,
    open,
    showBrokerFirm,
    returnTo,
    onClose
}: UnbookedOrdersDialogProps) {
    return (
        <Dialog open={open} onClose={onClose} fullScreen aria-labelledby={TitleId}>
            <DialogTitle id={TitleId}>{Translate('customer-calendar/unbooked/title')}</DialogTitle>
            <DialogContent>
                <UnbookedOrdersList
                    orders={orders}
                    showBrokerFirm={showBrokerFirm}
                    returnTo={returnTo}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{Translate('customer-calendar/booking/close')}</Button>
            </DialogActions>
        </Dialog>
    );
}

export default UnbookedOrdersDialog;
